// src/utils/amazon.js
//
// Builds an Amazon buy link for a book, mirroring the mobile app
// (src/screens/BookDetailScreen.js handleBuyOnAmazon), including the
// affiliate tag. Used by the public book detail page's primary CTA.
const AFFILIATE_TAG = 'bukito0b-21'
const AMAZON_BASE = 'https://www.amazon.co.uk'

export function buildAmazonUrl(book) {
  if (!book) return null

  let url
  const identifier = book.asin || book.amazonASIN || book.isbn13 || book.id

  if (book.amazon_buy_url) {
    url = book.amazon_buy_url
  } else if (identifier && /^97[89]\d{10}$/.test(identifier.toString())) {
    // 13-digit ISBN → search
    url = `${AMAZON_BASE}/s?k=${encodeURIComponent(identifier)}&i=stripbooks`
  } else if (identifier && identifier.toString().length === 10) {
    // 10-char ASIN → direct product page
    url = `${AMAZON_BASE}/dp/${identifier}`
  } else {
    // Fallback: title + author search
    const terms = [book.title, book.author].filter(Boolean).join(' ')
    url = `${AMAZON_BASE}/s?k=${encodeURIComponent(terms)}&i=stripbooks`
  }

  if (url && !url.includes('tag=')) {
    const separator = url.includes('?') ? '&' : '?'
    url = `${url}${separator}tag=${AFFILIATE_TAG}`
  }
  return url
}
